(function(){
'use strict';
var drawer=document.getElementById('cart-drawer');
var header=document.getElementById('site-header');
if(!drawer||!header)return;

function isOpen(){
  return drawer.classList.contains('open')||drawer.getAttribute('aria-hidden')==='false';
}
function setHeaderHeight(){
  var h=Math.ceil(header.getBoundingClientRect().height||0);
  if(h>0)document.documentElement.style.setProperty('--psi-cart-site-header-h',h+'px');
}
function syncChrome(){
  if(isOpen()){
    setHeaderHeight();
    document.body.classList.add('psi-cart-v411-open');
  }else{
    document.body.classList.remove('psi-cart-v411-open');
    document.documentElement.style.removeProperty('--psi-cart-site-header-h');
  }
}
function openCart(toggle){
  var overlay=document.getElementById('cart-overlay');
  drawer.setAttribute('aria-hidden','false');
  drawer.classList.add('open');
  if(overlay)overlay.classList.add('visible');
  document.body.classList.add('cart-open');
  if(toggle)toggle.setAttribute('aria-expanded','true');
}
function closeCart(){
  var close=drawer.querySelector('#cart-close');
  if(close)close.click();
}
function clearPointerFocus(toggle,event){
  if(!toggle||!toggle.blur||!event||event.detail===0)return;
  setTimeout(function(){if(document.activeElement===toggle)toggle.blur();},0);
}

/* v459 - restituisce il feedback tattile visivo senza usare :hover.
   Su touch il grigio resta solo per un istante e poi viene rimosso sempre. */
var cartToggle=document.getElementById('cart-toggle');
var cartTapTimer=null;
function endCartTap(){
  if(!cartToggle)return;
  cartToggle.style.removeProperty('background-color');
  if(cartTapTimer){clearTimeout(cartTapTimer);cartTapTimer=null;}
}
function startCartTap(event){
  if(!cartToggle||!window.matchMedia||!window.matchMedia('(max-width:900px) and (hover:none)').matches)return;
  if(event&&event.pointerType==='mouse')return;
  cartToggle.style.setProperty('background-color','#f4f4f4','important');
  if(cartTapTimer)clearTimeout(cartTapTimer);
  cartTapTimer=setTimeout(endCartTap,160);
}
if(cartToggle){
  if(window.PointerEvent){
    cartToggle.addEventListener('pointerdown',startCartTap,{passive:true});
    cartToggle.addEventListener('pointercancel',endCartTap,{passive:true});
  }else{
    cartToggle.addEventListener('touchstart',startCartTap,{passive:true});
    cartToggle.addEventListener('touchcancel',endCartTap,{passive:true});
  }
}

new MutationObserver(syncChrome).observe(drawer,{attributes:true,attributeFilter:['class','aria-hidden']});
window.addEventListener('resize',function(){if(isOpen())setHeaderHeight()},{passive:true});
window.addEventListener('orientationchange',function(){if(isOpen())setHeaderHeight()},{passive:true});
if(window.ResizeObserver){
  new ResizeObserver(function(){if(isOpen())setHeaderHeight()}).observe(header);
}

document.addEventListener('click',function(e){
  if(!e.target||!e.target.closest)return;

  var toggle=e.target.closest('#site-header #cart-toggle');
  if(toggle){
    clearPointerFocus(toggle,e);
    if(isOpen()){
      e.preventDefault();
      e.stopImmediatePropagation();
      closeCart();
    }else{
      /* Apertura immediata in capture: non dipende dal listener piu' pesante
         di theme.js. Il suo click successivo resta consentito ed e' idempotente. */
      openCart(toggle);
    }
    return;
  }

  if(!isOpen())return;
  var headerAction=e.target.closest('#site-header a,#site-header #search-toggle,#site-header #psi-burger');
  if(headerAction)closeCart();
},true);

syncChrome();
}());

/* v460 - riporta Svuota carrello nel footer senza duplicare la logica Ajax gia presente. */
(function(){
'use strict';

var drawer=document.getElementById('cart-drawer');
var footer=document.getElementById('cart-drawer-footer');
if(!drawer||!footer)return;

function syncFooterActions(){
  var inner=footer.querySelector('.psi-cart-footer-inner');
  var quote=inner&&inner.querySelector('#psi-cart-quote');
  if(!inner||!quote)return;

  var row=inner.querySelector('.psi-cart-secondary-actions');
  if(!row){
    row=document.createElement('div');
    row.className='psi-cart-secondary-actions';
    quote.parentNode.insertBefore(row,quote);
  }

  if(quote.parentNode!==row)row.appendChild(quote);

  var clear=row.querySelector('[data-psi-cart-clear-footer]');
  if(!clear){
    clear=document.createElement('button');
    clear.type='button';
    clear.className='psi-cart-clear-footer';
    clear.setAttribute('data-psi-cart-clear-footer','');
    clear.setAttribute('aria-label','Svuota carrello');
    clear.textContent='Svuota carrello';
    row.appendChild(clear);
  }
}

drawer.addEventListener('click',function(event){
  if(!event.target||!event.target.closest)return;
  var clear=event.target.closest('[data-psi-cart-clear-footer]');
  if(!clear)return;

  event.preventDefault();
  if(clear.disabled)return;

  var source=document.getElementById('cart-clear');
  if(!source||source.hidden||source.disabled)return;

  clear.disabled=true;
  clear.setAttribute('aria-busy','true');
  source.click();
});

syncFooterActions();
new MutationObserver(function(){
  window.requestAnimationFrame(syncFooterActions);
}).observe(footer,{childList:true,subtree:true});
}());
